/** Las propiedades de una fila, arriba de su página, como en Notion. */
import { Celda } from './Celdas'
import { ICONO_DE_TIPO, type Esquema } from './tipos'

export default function PropiedadesFila({ esquema, props, editable, alCambiar, alCrearOpcion }: {
  esquema: Esquema
  props: Record<string, unknown>
  editable: boolean
  alCambiar: (propId: string, valor: unknown) => void
  alCrearOpcion?: (propId: string, nombre: string) => string | null
}) {
  if (esquema.properties.length === 0) return null
  return (
    <div className="propiedades-fila" role="group" aria-label="Propiedades">
      {esquema.properties.map((p) => (
        <div className="propiedades-fila__fila" key={p.id}>
          <div className="propiedades-fila__nombre">
            <span aria-hidden="true" className="panel__tipo">{ICONO_DE_TIPO[p.type]}</span> {p.name}
          </div>
          <div className="propiedades-fila__valor">
            <Celda prop={p} valor={props[p.id]} editable={editable}
                   alCambiar={(v) => alCambiar(p.id, v)}
                   alCrearOpcion={editable ? alCrearOpcion : undefined} />
          </div>
        </div>
      ))}
    </div>
  )
}
